export default __webpack_public_path__ + "static/media/Expertise-Bg.9ed3df77.png";